import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionBlockModal = ({ status, onClose }) => {
  const history = useNavigate();

  const getMessage = () => {
    if (!status?.hasSubscription) {
      return 'This group does not have an active subscription. A subscription is required to add members.';
    }
    if (status?.isExpired && status?.isOverLimit) {
      return 'Your subscription has expired and your group exceeds the member limit.';
    }
    if (status?.isExpired) {
      return 'Your subscription has expired.';
    }
    if (status?.isOverLimit) {
      return `Your group has ${status.memberCount} member profiles, but your plan only includes ${status.maxMembers}.`;
    }
    if (status?.isAtLimit) {
      return `Your group has reached the maximum of ${status.maxMembers} member profiles allowed by your plan.`;
    }
    return 'Your subscription requires attention.';
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl leading-none"
        >
          &times;
        </button>
        <h2 className="text-xl font-bold text-red-600 mb-4">{status?.hasSubscription ? 'Subscription Upgrade Required' : 'Subscription Required'}</h2>
        <p className="text-gray-700 mb-6">{getMessage()}</p>
        <p className="text-gray-600 mb-6 text-sm">
          You can upgrade your subscription, purchase profile add-on blocks, or remove member profiles to continue.
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => history('/subscription')}
            className="w-full py-3 bg-[#5577FF] text-white rounded-md font-medium hover:bg-[#4466EE]"
          >
            View Subscription Plans
          </button>
          <button
            onClick={() => { onClose(); history('/members'); }}
            className="w-full py-3 border border-gray-300 text-gray-700 rounded-md font-medium hover:bg-gray-50"
          >
            Manage Members
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBlockModal;
